import React, { useState } from 'react';
import { CustomerServiceOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';
import './styles.less';
import businessImage from './business.jpg';
import contactImage from './concat.jpg';
import { useTranslation } from 'react-i18next';

export const ContactEntry = () => {
  const prefixCls = 'contact-entry';
  const [showBusiness, setShowBusiness] = useState(false);
  const { t } = useTranslation('app', { keyPrefix: 'layout.header' });

  const content = (
    <div className={`${prefixCls}-popover-content`}>
      <div className={`${prefixCls}-body`}>

        <div className={`${prefixCls}-card`}>
          <img
            src={contactImage}
            alt={t('contact_qr_alt')}
            className={`${prefixCls}-qrcode`}
          />
          <div className={`${prefixCls}-tips`}>{t('wechat_scan')}</div>
        </div>
        
        <div 
          className={`${prefixCls}-business-trigger`}
          onClick={() => setShowBusiness(!showBusiness)}
        >
          {showBusiness ? t('business_cooperation_hide') : t('business_cooperation_trigger')}
        </div>

        {showBusiness && (
          <div className={`${prefixCls}-card`}>
            <img
              src={businessImage}
              alt={t('business_qr_alt')}
              className={`${prefixCls}-qrcode`}
            />
            <div className={`${prefixCls}-tips`}>{t('business_cooperation_tip')}</div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      placement="bottomRight"
      trigger="hover"
      arrow={false}
      overlayClassName={`${prefixCls}-popover`}
    >
      <Button 
        className={`${prefixCls}-btn`}
        icon={<CustomerServiceOutlined className="icon" />}
        type="text"
      >
        {t('contact_customer_service')}
      </Button>
    </Popover>
  );
};
